import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

type SquaresContestResponse = {
  squares_contest_id: string;
  question_id?: string; // For new question-based system
  pickem_id?: string; // For new question-based system
  tenant_id: string;
  game_type: string;
  status: string;
  contest_name_en?: string;
  contest_name_fr?: string;
  contest_subtext_en?: string;
  contest_subtext_fr?: string;
  entry_fee: number;
  max_squares_per_user: number;
  start_time_utc?: string;
  row_team_id?: string;
  col_team_id?: string;
  row_team_display_name?: string;
  col_team_display_name?: string;
  sport: string;
  fixture_id?: string;
  total_prize_amount: number;
  total_entries_to_date: number;
  editable?: boolean;
  edit_message?: string;
  [key: string]: any;
};

type GetSquareResponse = {
  squares_contest: SquaresContestResponse;
};

export const getSquare = (id: string): Promise<GetSquareResponse> =>
  apiClient.get(`/api/admin/squares/${id}` as any) as Promise<GetSquareResponse>;

export const useGetSquareQuery = (id: string | undefined) => {
  return useQuery({
    queryKey: id ? queryKeys.squares?.detail(id) || ['squares', id] : ['squares', 'none'],
    queryFn: async () => {
      if (!id) throw new Error('Square ID is required');
      const response = await getSquare(id);
      return response; // apiClient already extracts response.data
    },
    enabled: !!id,
  });
};
